import { useBookmarkSelection } from '../../contexts/BookmarkSelectionContext';
import BookmarkBatchOperations from './BookmarkBatchOperations';
import MobileTopBar from './MobileTopBar';
import type { ViewMode } from '../../types/api';

interface BatchOperationsBarProps {
  viewMode?: ViewMode;
}

function BatchOperationsBar({ viewMode = 'unread' }: BatchOperationsBarProps) {
  const { isBatchMode } = useBookmarkSelection();

  return (
    <div>
      {/* Mobile Top Bar */}
      <MobileTopBar />

      {/* Desktop Top Bar */}
      {isBatchMode && (
        <div className="hidden w-full max-w-xl md:block">
          <BookmarkBatchOperations viewMode={viewMode} />
        </div>
      )}
    </div>
  );
}

export default BatchOperationsBar;
